import { DiagnosticSubmitWindowContent } from "@/page/adminWorker/DiagnosticSubmitWindowContent";
import type { ReactNode } from "react";
import { WindowStackHost, type WindowEntry } from "@/components/modal";
import { DatasetDetailWindowContent } from "@/page/datasetDetail/DatasetDetailWindowContent";
import { EvaluationResultsWindowContent } from "@/page/evaluationResults/EvaluationResultsWindowContent";
import { ScheduleOccurrencesWindowContent } from "@/page/training/schedules/ScheduleOccurrencesWindowContent";
import { SessionDatasetsWindowContent } from "@/page/training/sessionDatasets/SessionDatasetsWindowContent";
import { TrainingSessionWindowContent } from "@/page/training/TrainingSessionWindowContent";
import { SubmitWizardWindowContent } from "@/page/training/submit/SubmitWizardWindowContent";
import { UploadWindowContent } from "@/page/upload/UploadWindowContent";
import { windowStack, type WindowKind } from "@/app/windowStack";

type WindowContentProps = { entry: WindowEntry; active: boolean };

// kind 를 콘텐츠 컴포넌트에 대응시키는 레지스트리. 제네릭 호스트는 kind 를 모른다. 이 앱 호스트만 매핑을 안다.
const WINDOW_REGISTRY: Record<WindowKind, (props: WindowContentProps) => ReactNode> = {
  datasetDetail: DatasetDetailWindowContent,
  trainingSession: TrainingSessionWindowContent,
  trainingSubmit: SubmitWizardWindowContent,
  diagnosticSubmit: DiagnosticSubmitWindowContent,
  datasetUpload: UploadWindowContent,
  evaluationResults: EvaluationResultsWindowContent,
  scheduleOccurrences: ScheduleOccurrencesWindowContent,
  sessionDatasets: SessionDatasetsWindowContent,
};

// 앱 스코프 전체화면 창 호스트. 라우터(BrowserRouter) 안에 마운트한다. 그래서 최소화한 창이 화면
// 전환에서도 유지되고 복원된다. 콘텐츠도 useNavigate 같은 라우터 훅을 쓸 수 있다. 제네릭
// WindowStackHost 에 앱 스택과 레지스트리(renderWindow)를 주입한다.
export function AppWindowHost(): ReactNode {
  return (
    <WindowStackHost
      stack={windowStack}
      renderWindow={(entry, active) => {
        const Content = WINDOW_REGISTRY[entry.kind as WindowKind];
        return Content !== undefined ? <Content entry={entry} active={active} /> : null;
      }}
    />
  );
}
